import { createContext } from 'react';
import { useAuth } from '../hooks/useAuth';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const authData = useAuth();

  return (
    <UserContext.Provider value={authData}>
      {children}
    </UserContext.Provider>
  );
};